import { ISignupForm } from '@models/ISignupForm';
import axios from 'axios';

const signupFormGetProps = async (endpoint: string): Promise<ISignupForm> => {
  const { data } = await axios.get<ISignupForm>(endpoint);

  return data;
};

export default signupFormGetProps;
